import React from "react"
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"

import { productUnitsSymbol } from "constant"
import classes from "./StrrdmResolveTableRow.module.scss"

const StrrdmResolveTableRow = (props) => {
  const { requestedItem } = props

  const haveMissingItems =
    requestedItem.lossQuantity > 0

  const backgroundColor =
    haveMissingItems
      ? "var(--color-danger-alpha-25)"
      : "var(--color-success-alpha-25)"

  return (
    <tr style={{ backgroundColor }}>
      <td>
        {requestedItem.lossQuantity > 0
          ?
          <FaTimesCircle
            size={16}
            className={classes["times"]}
          />
          :
          <FaCheckCircle
            size={16}
            className={classes["check"]}
          />
        }
      </td>
      <td>
        {requestedItem.foodName}{" "}
        {requestedItem.isSimple ? "" : requestedItem.foodOptionName}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.requestedQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.acceptedQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.receivedQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.returnedToDestinationQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.returnedToSourceQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.reductionFromSourceQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {requestedItem.lossQuantity}
        {productUnitsSymbol[requestedItem.unit]}
      </td>
    </tr>
  )
}

export default React.memo(StrrdmResolveTableRow)